import React, { Component } from 'react'
import moment from 'moment'

class ClubDetails extends Component {
  render () {
    const c = this.props.info
    const f = this.props.fiscalyear
    return (
      <div>
        <ul className="club-info">
          <li>
            <span>Nome</span>{c.name}
          </li>
          <li>
            <span>Indirizzo</span>{c.address}
          </li>
          <li>
            <span>CAP</span>{c.postal_code}
          </li>
          <li>
            <span>Città</span>{c.city}
          </li>
          <li>
            <span>Provincia</span>{c.country}
          </li>
          <li>
            <span>Codice fiscale</span>{c.fiscal_code}
          </li>
          <li>
            <span>Partita IVA</span>{c.vat}
          </li>
          <li>
            <span>Iban</span>{c.iban}
          </li>
          <li>
            <span>Indirizzo e-mail</span>{c.email}
          </li>
          <li>
            <span>Nome e-mail</span>{c.email_name}
          </li>
          <li>
            <span>Inizio anno fiscale</span>{(c.start_date !== '') ? moment.unix(c.start_date).format('DD MMMM') : ''}
          </li>
          <li>
            <span>Fine anno fiscale</span>{(c.end_date !== '') ? moment.unix(c.end_date).format('DD MMMM') : ''}
          </li>
        </ul>
        <ul className="club-info sign">
          <li>
            <img src={c.signature} className='img' alt='signature' />
          </li>
        </ul>
        <ul className="club-info fy">
          <li>Anni fiscali presenti</li>
          {
            f !== null && (
              f.map((y, index) => {
                return (
                  <li key={index}>{moment.unix(y.start_date).format('ll')} - {moment.unix(y.end_date).format('ll')}</li>
                )
              })
            )
          }
        </ul>
      </div>
    )
  }
}

export default ClubDetails



// WEBPACK FOOTER //
// ./src/components/Club/ClubDetails.js